import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { EventPageTemplateBlank } from '../';
import { ImageItem } from './';
import { ImagesActions, PrintActions } from '../../../actions';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faPrint, faArrowLeft, faFrown } from '@fortawesome/fontawesome-free-solid';
import { Submit } from '../../Form';
import { LocalStorage, ImagesCache, beforeUnload } from '../../../helper';
import store from '../../../store';

import './printImagesPage.scss';

const {REACT_APP_LOCAL_STORAGE_PRINT_ACTIONS_ITEM_NAME} = process.env;

class PrintImagesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            localStoragePrintListArrayIndex: 0, // store index of last localStorage update
            eventID: null,
            printID: null,
            frame: false,
            exists: false,
            rotate: false,
            imagesPerPage: 8
        }

        this.cache = new ImagesCache();

        this.beforeUnload = new beforeUnload("האם הדפסת התמונות נכשלה?");
    }

    componentDidMount() {
        const {dispatch, match} = this.props;
        const {eventID, printID} = match.params;

        dispatch(ImagesActions.getAllImages(eventID));

        this.setState({eventID: eventID, printID: printID}, () => {
            // for sync between browser tabs
            // get data from main app tab (where user click on print button)
            this.dispatchFromLocalStorage();
            this.syncPrintList();
        });
    }

    dispatchFromLocalStorage() {
        const updatePrintByLocalStorage = LocalStorage.get(REACT_APP_LOCAL_STORAGE_PRINT_ACTIONS_ITEM_NAME);
        if(updatePrintByLocalStorage) {
            // update only the new list (from last update)
            for(let i = this.state.localStoragePrintListArrayIndex ; i < updatePrintByLocalStorage.length ; i++) {
                let {images, printID, frame, printed, rotate, imagesPerPage} = updatePrintByLocalStorage[i];
                store.dispatch(PrintActions.createPrintList({
                    images: images, 
                    frame: frame, 
                    printID: printID,
                    printed: printed,
                    rotate: rotate,
                    imagesPerPage: imagesPerPage,
                    storeInLocalStorage: false
                }));

                const updateState = {
                    localStoragePrintListArrayIndex: i
                }

                if(printID === this.state.printID) {
                    updateState.frame = frame
                    updateState.exists = true;
                    updateState.rotate = rotate;
                    updateState.imagesPerPage = imagesPerPage;
                }

                this.setState(updateState); 
            }
        }
    }

    print() {
        window.print();
    }

    successfullyPrint() {
        const {dispatch} = this.props;
        const {eventID, printID} = this.state;

        const images = this.getImages();
        if(!images) return;

        this.beforeUnload.remove(); // remove warnning message before leaving the page
        
        const serialized = images.map((item) => {
            return {
                id: item.id,
                printed: item.print
            }
        });

        dispatch(PrintActions.updateBulkImages(eventID, printID, {images: serialized}));
    }
    
    syncPrintList() {
        LocalStorage.onChange((event) => {
            if(event.key !== REACT_APP_LOCAL_STORAGE_PRINT_ACTIONS_ITEM_NAME) return;
            this.dispatchFromLocalStorage();
        });
    }

    onImageError(e) {
        if(e.target) e.target.style.display = 'none';
    }

    getImages() {
        const {images, print} = this.props;
        const {printID, eventID} = this.state;
        const printList = print.list && print.list[printID];
        const printListImages = printList && printList.images;
        const imagesList = images.list && images.list[eventID];

        if(!printList || !imagesList || !Array.isArray(printListImages)) return false;

        const reducer = (obj, val) => {
            obj[val._id] = val;
            return obj;
        }

        const serialized = imagesList.reduce(reducer, {});
        
        return printListImages.map((item) => {
            if(serialized[item.id]) item.url = serialized[item.id].url;
            return item;
        }).filter((item) => item.hasOwnProperty('url') && item.print > 0);
    }

    getAllCopies() {
        const imageForRender = this.getImages();
        if(!imageForRender) return false;

        // multiply image by image copies number
        const copiesList = [];
        
        for(let j = 0 ; j < imageForRender.length ; j++) {
            let item = imageForRender[j];
            for(let i = 0 ; i < item.print ; i++) {
                copiesList.push(item);
            }
        }

        return copiesList;
    }

    splitImagesToPages() {
        const {imagesPerPage} = this.state;

        const copiesList = this.getAllCopies();
        if(!copiesList) return false;
        
        const pages = [];
        const chunk = imagesPerPage;
        const end = copiesList.length / chunk;

        for(let i = 0 ; i < end ; i++) {
            let tmp = copiesList.splice(0, chunk);
            pages.push(tmp);
        }

        return pages;
    }

    renderImagesCopies() {
        const {frame, rotate} = this.state;
        const {page, size} = frame;

        const pages = this.splitImagesToPages();
        if(!pages) return false;

        const pageWrapperStyle = {
            width: window.innerWidth + 'px',
            height: ((window.innerWidth / page.width) * page.height) + 'px'
        }

        const pageStyle = {
            transform: `scale(${window.innerWidth / page.width}) ${rotate ? `rotate(90deg) translate(100%, 0%)` : ''}`, 
            transformOrigin: `top right`
        }

        let imageWidth = size.x;
        let imageHeight = size.y;

        return pages.map((page, index) => {
            return (
                <div  className="pageWrapper" style={pageWrapperStyle} key={index}>
                    <div className="page" style={pageStyle}>
                        {
                            page.map((img, index) => {
                                return <ImageItem 
                                    imageWidth={imageWidth}
                                    imageHeight={imageHeight}
                                    onError={this.onImageError.bind(this)}
                                    key={index}
                                    cache={this.cache}
                                    img={img}
                                />
                            })
                        }
                    </div>
                </div>
            )
        });
    }

    render() {
        const {print} = this.props;
        const {printID, exists, rotate, frame} = this.state;
        const images = this.renderImagesCopies();
        const printSuccess = print && print.list && print.list[printID] && print.list[printID].printed;

        // 2480 is width & 3508 is height of A4 in 300dpi
        let width = (frame && frame.page && frame.page.width) || 2480;
        let height = (frame && frame.page && frame.page.height) || 3508;

        if(printSuccess) window.close(); // close tab when print success

        return (
            <EventPageTemplateBlank>
                <style dangerouslySetInnerHTML={{__html: `
                    #printImagesPage .images-list .page {
                        width: ${width}px;
                        height: ${height}px;
                    }

                    #printImagesPage .images-list.rotate .page {
                        height: ${width}px;
                        width: ${height}px;
                    }

                    @media print {   
                        #printImagesPage .images-list .pageWrapper {
                            height: ${height-1}px !important; /* avoid printing blank page - remove 1px of img border (not image itself) */
                            overflow: hidden;
                        }
                        
                        @page {
                            size: ${width}px ${height}px;
                            page-break-after: avoid;
                            margin: 0;
                        }
                    }
                `}}></style>
                <div id="printImagesPage">
                    <div className={`fixed-header${!exists ? ' hide' : ''}`}>
                        <div className="print-button print" onClick={this.print.bind(this)}>
                            <FontAwesomeIcon icon={faPrint}/> להדפסה
                        </div>
                        <div className={`${printSuccess ? 'hide' : ''}`}>
                            <small>
                                לחצו על הכפתור לאחר הדפסה מוצלחת כדי שהמערכת תסמן את התמונות כתמונות שהודפסו
                                &nbsp;<FontAwesomeIcon icon={faArrowLeft}/>
                            </small>
                            &nbsp;
                            <Submit 
                                process={print.updateBulkImagesPrintProcess}
                                text="המגנטים הודפסו בהצלחה"
                                icon="faCheckCircle"
                                onClick={this.successfullyPrint.bind(this)}
                                className="print-button print-success"
                            />
                        </div>
                    </div>
                    <div className={`images-list${!exists ? ' hide' : ''}${rotate ? ' rotate' : ''}`}>
                        {images}
                    </div>
                    <div className={`print-list-unexists${exists ? ' hide' : ''}`}>
                        <div className="sad">
                            <FontAwesomeIcon icon={faFrown}/>
                        </div>
                        הדפסה זו לא קיימת יותר<br />
                        אנא צרו הדפסה חדשה
                    </div>
                </div>
            </EventPageTemplateBlank>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer,
        images: state.imagesReducer,
        print: state.printReducer
    }
}

const PrintImagesPageWithRedux = withRouter(connect(mapStateToProps)(PrintImagesPage));

export {PrintImagesPageWithRedux as PrintImagesPage};


// WEBPACK FOOTER //
// ./src/components/EventPage/print/PrintImagesPage.jsx